
import { Vue } from 'vue-class-component';
import { ElMessage } from 'element-plus';
import CustomerService from '@/services/customerService';
import RoleService from '@/services/roleService';
import ServiceCodeService from '@/services/serviceCodeService';
import ErrorCode from '@/constants/ErrorCode';
import AccountType from '@/constants/AccountType';
import * as countryAreaCode from '@/assets/data/countryAreaCode.json';
import UpdateCustomerModel from '../models/updateCustomerModel';
import CommonValidate from '../services/commonValidate';

export default class CustomerDetail extends Vue {
    private updateModel:UpdateCustomerModel=new UpdateCustomerModel();

    private countryAreaCodes = (countryAreaCode as any).default;

    private customer:any={};

    private resources = [];

    private customerId='';

    private accessGroups = [];

    private rules={
      name: [{
        required: true, whitespace: true, message: '请输入客户名', trigger: 'blur',
      }, { validator: CommonValidate.validateCustomerName, trigger: 'blur' }],
      phoneNo: [
        {
          required: true, whitespace: true, message: '请输入手机号码', trigger: 'blur',
        },
        { validator: CommonValidate.validatePhone, trigger: 'blur' },
      ],
      accessGroup: [{ required: true, message: '请选择角色', trigger: 'change' }],
    };

    mounted(): void {
      this.customerId = this.$route.params.id as string;
      this.loadRole();
      this.loadResource();
      this.loadData();
    }

    loadRole(): void {
      RoleService.getAll()
        .then((result) => {
          if (result.code === ErrorCode.Success) {
            this.accessGroups = result.data.filter(
              (it: any) => it.accountType === AccountType.CustomerAccount,
            );
          }
        })
        .catch((response) => {
          console.log(response);
        });
    }

    loadResource(): void {
      ServiceCodeService.getAll()
        .then((result) => {
          if (result.code === ErrorCode.Success) {
            this.resources = result.data;
          }
        })
        .catch((response) => {
          console.log(response);
        });
    }

    loadData(): void {
      CustomerService.get(this.customerId).then((result) => {
        if (result.code === ErrorCode.Success) {
          this.customer = result.data;
          this.updateModel.contacts = this.customer.contacts;
          this.updateModel.accessGroup = this.customer.accessGroup;
          this.updateModel.address = this.customer.address;
          this.updateModel.remark = this.customer.remark;
          this.updateModel.name = this.customer.name;
          this.updateModel.phoneNo = this.customer.phoneNo.split('-')[1] as string;
          this.updateModel.phonePrefix = this.customer.phoneNo.split('-')[0] as string;
        }
      }).catch((response) => {
        console.log(response);
      });
    }

    goBack() {
      this.$router.back();
    }

    save():void {
      const updateform:any = this.$refs.form;
      updateform.validate((valid:boolean) => {
        if (valid) {
          CustomerService.update(this.customerId, this.updateModel).then((response) => {
            if (response.code === ErrorCode.Success) {
              ElMessage.success(response.msg);
            } else {
              ElMessage.error(response.msg);
            }
          });
        }
      });
    }
}
